import React, { useContext, useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { toast } from "react-toastify";

import { AuthorizedLayout } from "../../components/AuthorizedLayout";
import VideoThumbnail from "./components/VideoThumbnail";
import LoadingIcon from "../../components/LoadingIcon";
import { AuthContext } from "../../providers/AuthProvider";
import astronauta from "../../assets/astronauta-perfil.png";
import iconHeart from "../../assets/Vector (23).png";
import { uploadFile } from "../../utils/aws";
import api from "../../utils/api";
import astrounautStandingWave from "../../assets/posesPNG/astronout-standing-wave.png";

import "./SelfieLetter.css";
import CenterMode from "./components/CenterMode";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CompleteProfileCard, useProfileComplete } from "../../components/CompleteProfileCard/CompleteProfileCard";

const SelfieLetter = () => {
  const navigate = useNavigate();
  const { user, updateUser } = useContext(AuthContext);
  const [videos, setVideos] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingVideos, setLoadingVideos] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const { isProfileComplete } = useProfileComplete();

  const getVideos = async () => {
    setLoadingVideos(true);
    try {
      const { data } = await api.get(`/talents/selfie_letter`);
      setVideos(data?.data?.attributes?.selfieLetterUrl || "");
      setLoadingVideos(false);
    } catch (error) {
      setLoadingVideos(false);
    }
  };

  const deleteVideos = async () => {
    setLoadingDelete(true);
    try {
      await api.delete(`/talents/selfie_letter/delete`);
      const { data } = await api.get(`/talents/talents/${user?.id}`);
      if (data) {
        updateUser(data);
        setLoadingDelete(false);
        window.location.reload();
      }
    } catch (error) {
      setLoadingDelete(false);
    }
  };

  const [progress, setProgress] = useState(0);

  const handleVideo = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setLoading(true);
      try {
        await uploadFile(selectedFile, user, (percent) => {
          setProgress(Math.min(percent, 100)); // Garante que o progresso não passe de 100%
        });

        const { data } = await api.get(`/talents/talents/${user?.id}`);
        if (data) {
          updateUser(data);
        }
        setLoading(false);
        setProgress(0);
        window.location.reload();
        toast.success("Video enviado com sucesso");
      } catch (error) {
        console.error("Erro ao enviar o video:", error);
        toast.error("Erro ao enviar o video");
        setLoading(false);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    getVideos();
  }, []);

  return (
    <AuthorizedLayout>
      <div className="containerSelfieLetter">
        {loadingVideos ? (
          <div className="containerLoader">
            <LoadingIcon />
          </div>
        ) : (
          <>
            <CompleteProfileCard />

            {/* Card de instrução quando tem vídeo E perfil completo */}
            {videos !== "" && isProfileComplete && (
              <div className="cardSendVideo">
                <div className="containerText">
                  <div className="title">Selfie Letter</div>
                  <div className="subtitle1">
                    Estamos torcendo para as empresas assistirem o seu vídeo!
                  </div>
                  <div className="subtitle2">
                    A Selfie Letter é uma oportunidade para você se apresentar de maneira autêntica. Quer atualizar a sua?
                  </div>

                  <label
                    className={`buttonSend ${loading && "loading"}`}
                    htmlFor="fupload-update"
                    style={{ "--progress": `${progress}%` }}
                  >
                    <div>
                      {loading ? `${progress}%` : "Enviar Outro Vídeo"}
                    </div>
                    <input
                      type="file"
                      id="fupload-update"
                      name="fupload-update"
                      accept=".mp4, .avi, .mov, .mkv, .wmv"
                      onChange={handleVideo}
                      style={{ display: "none" }}
                    />
                  </label>
                </div>
                <img src={astronauta} alt="SelfieLetter icon" />
              </div>
            )}

            {/* Conteúdo quando NÃO tem vídeo */}
            {videos === "" && (
              <div className="webSelfie">
                {!isProfileComplete && (
                  <div className="containerTextNew">
                    <div className="title">Envie Sua Selfie Letter</div>
                    <div className="titleContemt" style={{ marginBottom: '10px' }}>
                      Grave um vídeo contando quem é você para as empresas que podem te encontrar aqui na comunidade e aumente as suas oportunidades!
                    </div>
                  </div>
                )}

                <div className="titleContemt" style={{ marginBottom: '30px' }}>
                  Deixamos algumas dicas abaixo para você enviar o seu melhor vídeo. Estamos ansiosos para ver sua apresentação! 🙌
                </div>

                <CenterMode />

                <label
                  className={`buttonSelfie ${loading && "loading"}`}
                  htmlFor="fupload-new"
                  style={{ "--progress": `${progress}%` }}
                >
                  <div>
                    {loading ? `${progress}%` : "Enviar Vídeo"}
                  </div>
                  <input
                    type="file"
                    id="fupload-new"
                    name="fupload-new"
                    accept=".mp4, .avi, .mov, .mkv, .wmv"
                    onChange={handleVideo}
                    style={{ display: "none" }}
                  />
                </label>
              </div>
            )}

            {/* Conteúdo quando TEM vídeo */}
            {videos !== "" && (
              <div className="webSelfie">
                <VideoThumbnail videoUrl={videos} />

                <div
                  className={`buttonRemove ${loadingDelete && "loading"}`}
                  onClick={() => deleteVideos()}
                >
                  Remover Vídeo
                </div>
              </div>
            )}
          </>
        )}

        <div className="footerMobile">
          Desenvolvido com
          <img src={iconHeart} alt="" />
          <strong>© eComLovers®</strong>
        </div>
      </div>
    </AuthorizedLayout>
  );
};

export default SelfieLetter;
